module.exports = __webpack_public_path__ + "static/media/maricopa.a3fffded.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/maricopa.svg
// module id = 1140
// module chunks = 0